import { reverseGeocoding } from "../api/google-integration"

export type LatLng = {lat: number, lng: number}

export default class Geocoding{
    qualifier: string
    addresses: {[key:string]: string} = null

    constructor(qualifier?: string){   
        this.addresses = {}     
        this.qualifier = qualifier
    }

    public setQualifier = (qualifier) => {
        this.qualifier = qualifier
    }

    public buildUrlSearchParams = (latLngsStr: string[] = []): URLSearchParams => {
        const params = new URLSearchParams();
        latLngsStr.forEach(latLng => {                      
            if(!this.addresses[latLng]) params.append("latLngs", latLng);
        })

        return params
    }

    public fillAddresses = async (latLngs: LatLng[] = []) => {      
        
        if(!this.qualifier) return 
        
        const formattedLatLng = latLngs
            .filter((value, index, self) => self.indexOf(value) === index)
            .map(latLng => {
                const formatedValue = this.format(latLng)                
                return formatedValue
            })
            
        
        const params = this.buildUrlSearchParams(formattedLatLng)
        const res = await reverseGeocoding(this.qualifier, params)

        res?.forEach((result, index) => {            
            const {geocodingResult: {formattedAddress}} = result || {geocodingResult: {}}
            const key = formattedLatLng[index]

            this.addresses[key] = formattedAddress
        })
    }

    public getAddress = (latLng: LatLng) => {
        const key = this.format(latLng)           
        return this.addresses[key]
    }

    public format = (latLng: LatLng) => `${latLng.lat},${latLng.lng}`;
}